module.exports = __webpack_public_path__ + "img/logo-main-full-white.e53a95c6.png";